<template>
    <div class="gastouder-default">
        <div class="row">
            <div class="col-12 text-sm-left">
              <page-title
                  :title="'Urenregistratie'"
                  icon="hours-registration"
              />
            </div>
        </div>

        <nav>
            <ul class="nav nav-underline">
                <li class="nav-item">
                    <router-link
                        class="nav-link"
                        :class="{ active: route.path.startsWith('/gastouder/hours-open') }"
                        to="/gastouder/hours-open"
                    >Openstaande uren
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                        class="nav-link"
                        :class="{ active: route.path.startsWith('/gastouder/hours-submitted') }"
                        to="/gastouder/hours-submitted"
                    >Ingediende uren
                    </router-link>
                </li>
            </ul>
        </nav>

        <div class="py-3">
            <router-view />
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import {useRoute} from "vue-router";

export default {
    name: 'GastouderDefault',
    components: {PageTitle},
    data() {
        return {
            results: []
        }
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
    },
    created() {
        window.novict = {
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
    },
    methods: {
    },
    setup() {
        const route = useRoute()

        return {
            route,
        }
    },
}
</script>

<style scoped>
.nav-underline {
    gap: 1.5rem;
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    color: rgba(0,0,0,.5);
    border-bottom: .125rem solid transparent;
}
.nav-underline .nav-link:hover,
.nav-underline .nav-link:focus {
    color: rgba(0,0,0,.7);
    border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
    font-weight: 600;
    color: rgba(0,0,0,.9);
    border-bottom-color: #2479bc;
}

@media only screen and (max-width: 767px) {
    .nav-underline {
        display: block;
        border-bottom: none;
    }
    .nav-underline .nav-item:not(:last-child) {
        margin-bottom: .5rem;
    }
    .nav-underline .nav-link {
        padding: .375rem .75rem;
        border: 1px solid rgba(0,0,0,.1);
        border-radius: .25rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .nav-underline .nav-link.active,
    .nav-underline .show > .nav-link {
        border: 1px solid rgba(0,0,0,.5);
    }
}
</style>